import { css } from "@emotion/react";
import React, { Fragment, type ReactNode } from "react";
import { Flex } from "src/components/Flex.tsx";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { IconButton2 } from "src/components/IconButton2/IconButton2.tsx";
import { CopyButton } from "src/components/CopyButton/CopyButton.tsx";
import { useTranslation } from "react-i18next";

const icon = css`
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

// todo: maybe this Component belongs to SelectV2 component

export const SelectButtons = ({
  showButtons,
  additionalButtons,
  onViewButton,
  getCopyText,
}: {
  showButtons?: ("view" | "copy")[];
  additionalButtons?: ReactNode[];
  onViewButton?: () => void;
  getCopyText?: () => void;
}) => {
  const { t } = useTranslation();
  const buttons = [
    ...(showButtons || []).map((button) => {
      if (button === "view") {
        return (
          <IconButton2
            helperText={t("actions.view", {
              ns: TranslationNamespaceEnum.Common,
            })}
            onClick={() => {
              onViewButton?.();
            }}
            skin={"info"}
          >
            <i className={"icon-15-eye-vis"} />
          </IconButton2>
        );
      }

      return <CopyButton text={getCopyText?.() || ""} />;
    }),
    ...(additionalButtons || []).map((button, additionalButtonIndex) => (
      <Fragment key={(showButtons || []).length + additionalButtonIndex}>
        {button}
      </Fragment>
    )),
  ];
  if (buttons.length === 0) return null;
  return (
    <Flex flexShrink={0} flexDirection={"row"} gap={"5px"}>
      {buttons.map((button, index) => (
        <Flex key={index} css={icon}>
          {button}
        </Flex>
      ))}
    </Flex>
  );
};
